import { useAppState } from '../../AppStateProvider';
import UrlService from '../../services/UrlService';

import { useCrmContact } from './crmContact/useCrmContact';
import { useLinkedinContact } from './linkedinContact/useLinkedinContact';

enum ServicesToIntegrateWith {
  LinkedIn = 'LinkedIn',
  Hubspot = 'Hubspot',
  MicrosoftDynamics = 'MicrosoftDynamics',
  Salesforce = 'Salesforce',
  Salesloft = 'Salesloft',
  NotSupported = 'NotSupported',
}

const mapServiceUrlToKey = (urlString: string | undefined) => {
  const url = UrlService.createEventUrl(urlString);

  if (UrlService.isLinkedinUrl(url)) {
    return ServicesToIntegrateWith.LinkedIn;
  }
  if (UrlService.isHubspotUrl(url)) {
    return ServicesToIntegrateWith.Hubspot;
  }
  if (UrlService.isSalesloftUrl(url)) {
    return ServicesToIntegrateWith.Salesloft;
  }
  if (UrlService.isMicrosoftDynamicsUrl(url)) {
    return ServicesToIntegrateWith.MicrosoftDynamics;
  }
  if (UrlService.isSalesforceUrl(url) || UrlService.isSalesforceLightningUrl(url)) {
    return ServicesToIntegrateWith.Salesforce;
  }

  return ServicesToIntegrateWith.NotSupported;
};

const mappedServiceToHook = {
  [ServicesToIntegrateWith.LinkedIn]: useLinkedinContact,
  [ServicesToIntegrateWith.Hubspot]: useCrmContact,
  [ServicesToIntegrateWith.MicrosoftDynamics]: useCrmContact,
  [ServicesToIntegrateWith.Salesforce]: useCrmContact,
  [ServicesToIntegrateWith.Salesloft]: useCrmContact,
  [ServicesToIntegrateWith.NotSupported]: () => ({ isLoading: false, contact: null }),
};

export const useContact = () => {
  const { url: urlString } = useAppState();
  const serviceKey = mapServiceUrlToKey(urlString);

  return mappedServiceToHook[serviceKey]();
};
